import { Component, OnInit } from '@angular/core';
import {RouterService} from "@biletix/core/services/router.service";

@Component({
  standalone: false,
  selector: 'btx-third-empty-footer',
  templateUrl: './empty-footer.component.html',
  styleUrls: ['./empty-footer.component.scss']
})
export class ThirdEmptyFooterComponent implements OnInit {

  constructor(public routerService:RouterService) { }

  ngOnInit() {
  }

}
